/**
 * TanStack Query hooks for `delegated-payment-processing`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	delegatedPaymentProcessingQueryKeys,
	type CreateDelegatedPaymentProcessingBody,
	type ListDelegatedPaymentProcessingResponse,
	type DelegatedPaymentProcessingRow,
} from "./api";

export function useDelegatedPaymentProcessingList(): UseQueryResult<ListDelegatedPaymentProcessingResponse, Error> {
	return useQuery({
		queryKey: delegatedPaymentProcessingQueryKeys.list(),
		queryFn: list,
	});
}

export function useDelegatedPaymentProcessingCreate(): UseMutationResult<DelegatedPaymentProcessingRow, Error, CreateDelegatedPaymentProcessingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: delegatedPaymentProcessingQueryKeys.all });
		},
	});
}

export function useDelegatedPaymentProcessingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: delegatedPaymentProcessingQueryKeys.all });
		},
	});
}
